import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';
import ViewStateContainer from 'routes/Documents/containers/ViewStateContainer';

import Relapse from '../components/Relapse';
import { actions } from 'store/newDocumentStore';

const RelapseContainer = ({ edit, create }) => (
  <DocumentLoader names={['relapse']}>
    <DocumentProvider>
      <ViewStateContainer>
        <Relapse onStartEdit={edit} onCreate={create} />
      </ViewStateContainer>
    </DocumentProvider>
  </DocumentLoader>
);

RelapseContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(RelapseContainer);
